// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3RGFY","col":"styles_col__A5yrf","fulfillmentStatus":"styles_fulfillmentStatus__1OrWG","emailCol":"styles_emailCol__1OHNU"};